export const name = 'verticalMenu' as const
